import { Process } from "@/lib/interfaces/embed";
import { Card } from "../../../ui/components/ui/card";

export function JobPostsV2Process({ brandColor, process }: { brandColor: string; process?: Process }) {
  const cards = (process?.processCards || []).slice().sort((a, b) => (a.orderNumber ?? 0) - (b.orderNumber ?? 0));
  if (!process || cards.length === 0) return null;

  const fallbackTitle = `So einfach geht's - ${cards.length} Schritte`;
  const title = process.title?.trim() ? process.title : fallbackTitle;

  return (
    <div>
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-gray-900">{title}</h2>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map((card, idx) => (
          <Card key={card._id || `${card.title}-${idx}`} className="p-6 shadow-md transition-shadow hover:shadow-lg">
            <div className="text-[10px] font-semibold tracking-widest" style={{ color: brandColor }}>
              SCHRITT {card.orderNumber ?? idx + 1}
            </div>
            <div className="mt-3 text-sm font-semibold text-gray-900">{card.title}</div>
            <div className="mt-2 text-sm text-gray-600 leading-relaxed">{card.description}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
